import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'src/app/utils/moment';

@Injectable({
  providedIn: 'root'
})

export class TranslateConfigService {

  currentLang: any;

  constructor(
    private translateService: TranslateService,
  ) {
    this.currentLang = localStorage.getItem('lang');
  }

  getDefaultLanguage(){
    if (this.currentLang) {
      this.translateService.setDefaultLang(this.currentLang);
    } else {
      localStorage.setItem('lang', this.translateService.getBrowserLang()!);
      this.currentLang = this.translateService.getBrowserLang();
      //this.translateService.setDefaultLang(this.currentLang);
    }
    return this.currentLang;
  }

  setLanguage(setLang: string) {
    this.currentLang = setLang;
    this.translateService.use(setLang);
    localStorage.setItem('lang', setLang);
    moment.locale(setLang);
  }

  getCurrentLang() {
    return this.currentLang;
  }

  t(key: string, params?: Record<string, unknown>): string {
    return this.translateService.instant(key, params);
  }

  translate(key: string, params?: Record<string, unknown>): string {
    return this.t(key, params);
  }
}
